export default __webpack_public_path__ + "static/media/uploadIcon.8dfe45b2.svg";